var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "root" }, [
    _c("div", { staticClass: "header" }, [_c("DesignSummary")], 1),
    _vm._v(" "),
    _c("div", { staticClass: "design" }, [_c("Design")], 1),
    _vm._v(" "),
    _c("div", { staticClass: "footer" }, [_c("DesignImportExport")], 1)
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2834a1af", { render: render, staticRenderFns: staticRenderFns })
  }
}